module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/tables_lv-6332324ec8522737f124f0ae623a1676.webp";